import React from 'react';

function ImageComponent({ src, altText = '' }) {
  return (
    <img src={src} alt={altText} style={{ width: '80%', height: 'auto' }} />
  );
}

export default ImageComponent;